import { Facebook, Twitter, Linkedin, Instagram, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import syntelliteLogo from "../../assets/images/Syntellite-labs-logo.png";

export default function Footer() {
  const footerLinks = {
    Courses: [
      { name: "All Courses", href: "/courses" },
      { name: "Web Development", href: "/courses?category=frontend" },
      { name: "Data Science", href: "/courses?category=data-science" },
      { name: "AI/ML", href: "/courses?category=ai-ml" },
    ],
    Internships: [
      { name: "All Internships", href: "/internships" },
      { name: "Full-Stack", href: "/internships?category=fullstack" },
      { name: "Frontend", href: "/internships?category=frontend" },
      { name: "Backend", href: "/internships?category=backend" },
    ],
    "Training Programs": [
      { name: "Corporate Training", href: "/training" },
      { name: "Placement Guidance", href: "/placement-guidance" },
    ],
    "Live Webinars": [{ name: "Upcoming Webinars", href: "/webinars" }],
    Company: [{ name: "About Us", href: "/about" }],
    Support: [
      { name: "Contact Us", href: "/contact" },
      { name: "Terms and Conditions", href: "/terms-and-conditions" },
      {
        name: "Cancellation and Refund Policy",
        href: "/cancellation-and-refund-policy",
      },
      {
        name: "Shipping and Delivery Policy",
        href: "/shipping-and-delivery-policy",
      },
    ],
  };

  return (
    <footer
      className="border-t border-gray-200"
      style={{ backgroundColor: "hsl(var(--website-background))" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-12">
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="font-semibold text-gray-900 mb-4">{category}</h3>
              <ul className="space-y-2">
                {links.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.href}
                      className="text-sm text-gray-600 hover:text-primary transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center">
            <div className="mb-6 lg:mb-0">
              <Link to="/" className="flex items-center">
                <img src={syntelliteLogo} alt="Syntellite Labs" className="h-8" />
              </Link>
            </div>

            <div>
              <h3 className="font-semibold text-gray-900 mb-4 text-center">
                Follow us
              </h3>
              <div className="flex space-x-4">
                <a
                  href="https://www.linkedin.com/company/syntellite-innovations-private-limited/"
                  target="_blank"
                  className="text-gray-600 hover:text-primary transition-colors"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
                <a
                  href="https://www.instagram.com/syntellite/"
                  target="_blank"
                  className="text-gray-600 hover:text-primary transition-colors"
                >
                  <Instagram className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-sm text-gray-600">
                © 2024 Syntellite Labs. All rights reserved.
              </p>
            </div>
            <div className="flex items-center space-x-6"></div>
          </div>
        </div>
      </div>
    </footer>
  );
}
